import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const PinterestIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={`logo-24-24 ${className ? className : ''}`}
            fill='none'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M11.9951 0.000488281C5.36076 0.000488281 0 5.37111 0 11.9955C0 17.0799 3.15919 21.4238 7.62156 23.1712C7.51296 22.2234 7.42411 20.7623 7.66104 19.7257C7.87824 18.7878 9.06293 13.7627 9.06293 13.7627C9.06293 13.7627 8.70754 13.042 8.70754 11.9857C8.70754 10.3172 9.67502 9.0733 10.8795 9.0733C11.9062 9.0733 12.3998 9.84334 12.3998 10.7615C12.3998 11.7882 11.7482 13.3283 11.4027 14.7598C11.1164 15.9544 12.0049 16.9318 13.1798 16.9318C15.3122 16.9318 16.9511 14.6809 16.9511 11.4427C16.9511 8.56981 14.8877 6.56569 11.9358 6.56569C8.51995 6.56569 6.51583 9.12265 6.51583 11.7685C6.51583 12.7952 6.91073 13.9009 7.40436 14.5032C7.5031 14.6216 7.51296 14.7302 7.48334 14.8487C7.3945 15.2239 7.18716 16.0433 7.14768 16.2111C7.09831 16.4283 6.96996 16.4777 6.7429 16.3691C5.26202 15.6582 4.33402 13.4666 4.33402 11.7092C4.33402 7.9281 7.07856 4.45297 12.2616 4.45297C16.4179 4.45297 19.6561 7.41471 19.6561 11.3834C19.6561 15.52 17.0498 18.8471 13.4364 18.8471C12.2221 18.8471 11.0769 18.2152 10.6919 17.4649C10.6919 17.4649 10.0897 19.7553 9.94159 20.318C9.67502 21.3645 8.94446 22.6677 8.45083 23.4674C9.57631 23.8129 10.761 24.0005 12.0049 24.0005C18.6294 24.0005 24 18.6299 24 12.0054C23.9901 5.37111 18.6195 0.000488281 11.9951 0.000488281Z'
                fill={color}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default PinterestIcon;
